{
  "Thank-you message (optional)": "הודעת תודה (אופציונלי)",
  "Shown after a successful submission when no redirect URL is configured. Leave blank for the default message.": "מוצגת לאחר שליחה מוצלחת כשלא מוגדרת כתובת להפניה. השאירו ריק לשימוש בהודעת ברירת המחדל.",
  "Advisor": "יועץ",
  "A financial practice: pension and insurance agents, advisors, accountants, lawyers.": "משרד פיננסי: סוכני ביטוח ופנסיה, יועצים, רואי חשבון, עורכי דין.",
  "Lectures and files on this business's website, each with a page and a QR code": "הרצאות וקבצים באתר של העסק, לכל אחד עמוד וקוד QR",
  "Library switched on": "הספרייה הופעלה",
  "Library switched off": "הספרייה כובתה",
  "Website library": "ספריית האתר",
  "Deleted": "נמחק",
  "File replaced. The page and QR code stay the same.": "הקובץ הוחלף. העמוד וקוד ה־QR נשארים אותו דבר.",
  "Lectures and files": "הרצאות וקבצים",
  "Talks you've given and files you hand out, each with its own page on your website and a QR code for the last slide. A file for name and number turns every download into a WhatsApp lead tagged with the lecture.": "הרצאות שנתתם וקבצים שאתם מחלקים, לכל אחד עמוד משלו באתר וקוד QR לשקופית האחרונה. קובץ בתמורה לשם ומספר הופך כל הורדה לליד בוואטסאפ, מתויג לפי ההרצאה.",
  "File uploads aren't available on this platform right now.": "העלאת קבצים לא זמינה כרגע בפלטפורמה הזו.",
  "The pages go live when you publish your website.": "העמודים יעלו לאוויר כשתפרסמו את האתר.",
  "Nothing uploaded yet.": "עוד לא הועלה כלום.",
  "downloads": "הורדות",
  "leads": "לידים",
  "QR as SVG": "QR כ־SVG",
  "We couldn't make the PNG. Download the SVG instead.": "לא הצלחנו ליצור PNG. הורידו את ה־SVG במקום.",
  "QR as PNG": "QR כ־PNG",
  "Replace file": "החלפת קובץ",
  "Confirm delete": "אישור מחיקה",
  "Delete the file and its page? Printed QR codes will stop working.": "למחוק את הקובץ ואת העמוד שלו? קודי QR שהודפסו יפסיקו לעבוד.",
  "PDF, PowerPoint, Word, Excel, PNG or JPEG, up to {mb} MB each and {n} in all.": "PDF, PowerPoint, Word, Excel, PNG או JPEG, עד {mb} MB לקובץ ועד {n} בסך הכול.",
  "Upload a lecture or file": "העלאת הרצאה או קובץ",
  "File": "קובץ",
  "Kind": "סוג",
  "Lecture": "הרצאה",
  "Where it was given": "איפה ניתנה",
  "Who can download it": "מי יכול להוריד",
  "For name and number: visitors leave a name and mobile number first, and become a WhatsApp lead tagged with this item.": "בתמורה לשם ומספר: המבקרים משאירים קודם שם ומספר נייד, והופכים לליד בוואטסאפ שמתויג לפי הפריט הזה.",
  "For name and number": "בתמורה לשם ומספר",
  "Open download": "הורדה חופשית",
  "Hidden": "מוסתר",
  "The page address and QR code stay the same when you edit, so anything already printed keeps working.": "כתובת העמוד וקוד ה־QR נשארים אותו דבר כשעורכים, כך שכל מה שכבר הודפס ממשיך לעבוד.",
  "Worth checking": "כדאי לבדוק",
  "Fine": "תקין",
  "To update": "לעדכן",
  "Practice details": "פרטי המשרד",
  "Sections of the Advisor look. Only state what is true: credentials, licence numbers and figures are yours to give.": "חלקים של עיצוב יועץ. כתבו רק מה שנכון: הסמכות, מספרי רישיון ונתונים, רק מכם.",
  "Credentials": "הסמכות וניסיון",
  "Value, e.g. 20 or MBA": "ערך, למשל 20 או MBA",
  "What it means": "מה זה אומר",
  "Add a credential": "הוספת הסמכה",
  "How it works": "איך זה עובד",
  "Step": "שלב",
  "Add a step": "הוספת שלב",
  "What we check (example card)": "מה בודקים (כרטיס לדוגמה)",
  "What is checked": "מה בודקים",
  "Note": "הערה",
  "Add a check": "הוספת בדיקה",
  "Show the retirement calculator": "הצגת מחשבון הפרישה",
  "Licence number": "מספר רישיון",
  "Footer notice": "הודעה בתחתית האתר",
  "The regulatory notice under your site, e.g. that the content isn't personal advice.": "ההודעה הרגולטורית בתחתית האתר, למשל שהתוכן אינו ייעוץ אישי.",
  "Logo": "לוגו",
  "Shown in the header. Until you upload one, the icon is.": "מוצג בראש האתר. עד שתעלו לוגו, מוצג האייקון.",
  "Portrait": "תמונה אישית",
  "Shown beside About us.": "מוצגת ליד \"עלינו\".",
  "PNG, JPEG or WebP, under 300 KB.": "PNG, JPEG או WebP, עד 300 KB."
}

